
/* injects from baggage-loader */
var Template = require('./template.js');

import React, { Component, createRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { createSelector } from "reselect";
import moment from "moment";
import Zergling from '../../../helpers/zergling';
import Config from "../../../config/main";
import { periodsBySports } from "../../../../dev/constants/asianMarketNamesFilter";
import { UpperScreen } from '../../../actions/terminal';
import { toggleGameEventsInList } from '../../../actions/ui';
import { framesCount } from "../../../helpers/sport/gameInfo";
import { t } from "../../../helpers/translator";
import { MarketContext } from "../gameListAsian/marketContext";
import { UIMixin } from "../../../mixins/uiMixin";
import { OpenPopup } from "../../../actions/ui";
import { broadcast, broadcastChannels } from "../../../helpers/broadcast";
import Helpers from "../../../helpers/helperFunctions";

class AsianGame extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filter: props.game && props.game.marketGroups[0],
            openFilters: false,
        };
        this.dropdownElementRef = createRef();
        this.openFilters = this.openFilters.bind(this);
        this.outsideClickListener = this.outsideClickListener.bind(this);
        this.scoreFramesCount = props.game && framesCount(props.game.stats);
        this.selectFilter = this.selectFilter.bind(this);
        this.setDateByGameType = this.setDateByGameType.bind(this);
        this.upperScreenStatistics = this.upperScreenStatistics.bind(this);
        this.upperScreenStreem = this.upperScreenStreem.bind(this);
        this.openBetBuilder = this.openBetBuilder.bind(this);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.filter === undefined) {
            return { ...prevState, filter: nextProps.game && nextProps.game.marketGroups[0] };
        }
        return null;
    }

    /**
     * @name selectFilter
     * @param {string} type
     * @description selected game markets filter
     * @return {function}
     */
    selectFilter(type) {
        return () => {
            this.setState({ filter: type });
            this.openFilters();
        };
    }

    outsideClickListener(e) {
        if (!this.dropdownElementRef.current?.contains(e.target)) {
            this.state.openFilters &&  this.setState({ openFilters: false });
            window.removeEventListener('click', this.outsideClickListener);    
        }

    }

    /**
     * @name openFilters
     * @description opened and closed game markets filters
     * @return {undefined}
     */
     openFilters(event) {
        !this.state.openFilters && window.addEventListener('click', this.outsideClickListener);
        this.setState({ openFilters: !this.state.openFilters });
    }
    /**
     * @name setDateByGameType
     * @param {object} game
     * @param {string} gameType
     * @description return game type specific node element for date
     * @return {nodeelement}
     */
    setDateByGameType(game, gameType) {
        switch (gameType) {
            case "live":
                return (game.info && game.info.current_game_state !== undefined &&
                    <b className="date-view-t">{(game.info.current_game_state.replace(/[^\d.]/g, '')
                        ? t(periodsBySports[game.alias]) + " " + game.info.current_game_state.replace(/[^\d.]/g, '')
                        : t(game.info.current_game_state)) + " " + (game.info.current_game_time
                            ? (game.info.current_game_time + t(" min"))
                            : '')}</b>);
            case "today":
                return (<b className="date-view-t">{moment.unix(game.start_ts).format(Config.main.timeFormat)}</b>);
            default:
                return (<b className="date-view-t">{moment.unix(game.start_ts).format(Config.main.dateFormat) + " / " +  moment.unix(game.start_ts).format(Config.main.timeFormat)}</b>);
        }
    }
    genericTemplate(teamNummber) {
        return (
            <p className="a-team-name-v">
                <span>{this.props.game[`team${teamNummber}_name`]}</span>
                <b>
                    {
                        this.props.game.info[`score${teamNummber}`] && (
                            <>
                                {this.props.sportAlias === "Tennis" ? <i>{this.props.game.stats && this.props.game.stats.passes && this.props.game.stats.passes[`team${teamNummber}_value`] || "-"}</i>
                                    : <i className="score-v">{this.props.game.info[`score${teamNummber}`]}</i>}
                                {this.scoreFramesCount.map((frame, index, currentArray) => <i key={index} className={(currentArray.length - 1 === index) ? 'active' : ''}>{this.props.game.stats["score_set" + frame][`team${teamNummber}_value`] || "0"}</i>)}
                                {/* <i className='active'>{t(this.props.game.info[`score${teamNummber}`] || '')}</i> */}
                                {this.props.game.info.pass_team === ('team' + teamNummber) ? (<b className={"mini-icon mini-icon-ball " + this.props.sportAlias} />) : null}
                            </>
                        )
                    }
                </b>
            </p>
        );
    };
    singleScoreTemplate(teamNummber) {
        return <p className="a-team-name-v">
            <span>{this.props.game[`team${teamNummber}_name`]}</span>
            <b>
                {
                    this.props.game.info[`score${teamNummber}`] && (<i className="score-v">{this.props.game.info[`score${teamNummber}`]}</i>)
                }
            </b>
        </p>
    };

    horseRacingTemplate(teamNummber) {
        return <p className="a-team-name-v">
            <span>{this.props.game[`team${teamNummber}_name`]}</span>
        </p>
    };
    setScore(game, gameType, teamNummber) {
        switch (gameType) {
            case "live":
                switch (this.props.sportAlias) {
                    case "CyberFootball":
                    case "Soccer":
                    case "CounterStrike":
                        return this.singleScoreTemplate(teamNummber);
                    case "HorseRacing":
                        return this.horseRacingTemplate(teamNummber);
                    default:
                        return this.genericTemplate(teamNummber);
                }
            case "today":
                return (<p className="a-team-name-v"><span>{game[`team${teamNummber}_name`]}</span></p>);
            default:
                return (<p className="a-team-name-v"><span>{game[`team${teamNummber}_name`]}</span></p>);
        }
    }
    openBetBuilder() {
        const { game, OpenPopup } = this.props;
        game.sportcast_id && OpenPopup('betBuilder', { title: `${game.team1_name} vs ${game.team2_name}`, sportcastId: game.sportcast_id});
    }
    async upperScreenStreem(stream) {
        let isDualscreen = sessionStorage.getItem("dualscreen");
        const response = await Zergling.get({ video_id: stream.video_id, provider: stream.provider_id, use_hls: true }, 'video_url');

        if (!response) return;

        
        const hlsData = {
            hlsUrl: response,
        }

        // const hlsData = await fetchRequest(response, '', 'GET', { dynamicContentType: true });

        // if (!hlsData?.hlsUrl) return;

        if (Helpers.isSplitScreenAvailable()) {
            return broadcast.dispatchEvent(new CustomEvent(broadcastChannels.SplitScreenChange, {
                detail: { command: 'Video', id: stream.video_id, url: hlsData.hlsUrl, providerId: stream.provider_id }
            }));
        }

        if (isDualscreen === 'true') {
            return this.props.UpperScreen({
                type: "Video",
                id: stream.video_id,
                videoURL: hlsData.hlsUrl,
                tv_type: stream.provider_id
            });
        }

        let params = {
            url: hlsData.hlsUrl,
            providerId: stream.provider_id,
            gmaeId: stream.video_id
        };

        this.props.OpenPopup("videoStream", params);
    }

    upperScreenStatistics() {
        const isDualscreen = sessionStorage.getItem("dualscreen") || "false";
        const { game, gameType } = this.props;

        if (!game) return;

        if (Helpers.isSplitScreenAvailable()) {
            broadcast.dispatchEvent(new CustomEvent(broadcastChannels.SplitScreenChange, {
                detail: { command: 'Statistics', id: game.id, url: "", providerId: 0 }
            }));
        } else if (isDualscreen === "true") this.props.UpperScreen("Statistics", game.id, "", 0);
        else if (Config.urlForDualScreenStatistics) {
            const envLang = Config.env.lang;
            const defaulUrlTakenFromConfig = Config.urlForDualScreenStatistics + Config.main.availableLanguages[envLang].short.toLowerCase();
            const urlHardCodePart = defaulUrlTakenFromConfig + "/external/page/h2h/";
            const url = urlHardCodePart + game.team1_id + "/" + game.team2_id;
            this.props.OpenPopup("statisticsPopup", { url });
        }
    }
    render() {
        return Template.default.apply(this); //eslint-disable-line no-undef
    }
}

AsianGame.contextType = MarketContext;

AsianGame.propTypes = {
    gameId: PropTypes.number,
    selectorKey: PropTypes.string,
    marketsSelectorKey: PropTypes.string,
    game: PropTypes.object,
    gameMarketData: PropTypes.object,
    gameType: PropTypes.string,
    toggleGameEventsInList: PropTypes.func.isRequired
};

const mapStateToProps = (_, ownParams) => {

    return createSelector(
        [
            state => state.asianGameList[ownParams.selectorKey][ownParams.gameId] && JSON.stringify(state.asianGameList[ownParams.selectorKey][ownParams.gameId]),
            state => state.asianGameList[ownParams.marketsSelectorKey]?.game[ownParams.gameId] && JSON.stringify(state.asianGameList[ownParams.marketsSelectorKey].game[ownParams.gameId]),
            state => state.uiState.multiComponent.array,
            state => state.uiState.multiComponent.cursor,
            state => state.terminal.boostedOddsGameIds,
            state => state.routing.locationBeforeTransitions.pathname
        ],
        (data, marketsData, gameArray, cursor, boostedOddsGameIds, pathname) => {

            return {
                game: data && JSON.parse(data),
                gameMarketData: marketsData && JSON.parse(marketsData),
                gameArray,
                cursor,
                boostedOddsGameIds,
                pathname
            };
        });
};
const mapDispachToProps = (dispatch) => {
    return {
        toggleGameEventsInList: (bool, gameId) => dispatch(toggleGameEventsInList(bool, gameId)),
        UpperScreen: (type, id, videoURL, tvType) => dispatch(UpperScreen({ type: type, id, videoURL: videoURL, tv_type: tvType })),
        OpenPopup: (type, url) => dispatch(OpenPopup(type, url))
    };
};

export default connect(mapStateToProps, mapDispachToProps)(UIMixin({ Component: AsianGame }));
